import { useEffect } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { IDexTrade } from '@kattana-io/common';
import Image from '../../../atoms/Image';
import Text from '../../../atoms/Text';
import eye from '../../../assets/images/eye.svg';
import paper from '../../../assets/images/paper.svg';
import { actionShowModal } from '../../../actions/modal';
import { ModalTypes } from '../../../reducers/modal';

export interface IStatsMobileProps {
  data: any; // we don't have correct type for this
  quote_decimals: number;
  quote: string | undefined;
  address: string | undefined;
  chain: string;
  actionShowModal: (type: ModalTypes, props: any) => void;
  short?: boolean;
  exchange?: string;
}

const StatsMobile = (props: IStatsMobileProps) => {
  const openModal = () =>
    props.actionShowModal(ModalTypes.wallet, {
      wallet: props.data.wallet,
      address: props.address,
      chain: props.chain,
      timeframe: 'week',
      exchange: props.exchange,
    });

  useEffect(() => {
    setTimeout(ReactTooltip.rebuild, 0);
  }, []);

  const tradesFiltered = props.data?.tradesWithThisWallet?.reduce(
    (acc: { buy: IDexTrade[]; sell: IDexTrade[] }, item: IDexTrade) => {
      item.buy === 1 ? acc.buy.push(item) : acc.sell.push(item);
      return acc;
    },
    { buy: [], sell: [] }
  ) || { buy: null, sell: null };

  const buy = tradesFiltered.buy
    ? tradesFiltered.buy.length
    : props.data.buy_count;
  const sell = tradesFiltered.sell
    ? tradesFiltered.sell.length
    : props.data.sell_count;

  return (
    <div className='table_mobile__card__footer__row'>
      <div className='table_mobile__card__footer__row__text'>
        <Text size={12}>Statistics</Text>
      </div>
      <div className='table_mobile__card__footer__row__activity_group'>
        {!props.short && (
          <div className='table_mobile__card__footer__row__activity_group__icon'>
            <Image data-tip='Bot / Smart Contract' src={paper} size='m' />
          </div>
        )}
        <div className='table_mobile__card__footer__row__activity_group__icon'>
          <div className='table_mobile__card__footer__row__activity_group__icon__number'>
            <Text size={10} className='text--grey-200 text--weight-500'>
              {buy + sell}
            </Text>
          </div>
        </div>
        <div
          onClick={buy + sell > 1 ? openModal : undefined}
          className='table_mobile__card__footer__row__activity_group__icon'
        >
          <Image
            data-tip='Show more trades with this wallet'
            src={buy + sell > 1 ? eye : undefined}
            size='s'
          />
        </div>
      </div>
    </div>
  );
};

export default connect(null, { actionShowModal })(StatsMobile);
